!function (t, n) {
  function r(t) {
    var n,
        r,
        a = {};
    return p(t.included, function (t) {
      var n = t.type + "-" + t.id;
      a[n] = t;
    }), i(t.data) ? n = f(t.data, function (t) {
      return e(t, a), o(t);
    }) : c(t.data) && (e(t.data, a), n = o(t.data)), r = {
      data: n,
      jsonapi: t.jsonapi || {}
    }, t.meta && (r.meta = t.meta), t.errors && (r.errors = t.errors), t.links && (r.links = t.links), r;
  }

  function e(t, n, r) {
    t.relationships && (r = r ? r.concat([t]) : [t]), p(t.relationships, function (e, o) {
      e && c(e.meta) && (t.meta = t.meta || {}, t.meta[o] = e.meta), e.data && (i(e.data) ? t.attributes[o] = f(e.data, function (t) {
        return a(t, n, r);
      }) : t.attributes[o] = a(e.data, n, r));
    });
  }

  function a(t, n, r) {
    var a, i;
    if (a = l(r, {
      id: t.id,
      type: t.type
    })) return t;
    var u = t.type + "-" + t.id;
    if (i = n[u], !i) return t;
    e(i, n, r);
    var s = {};
    return t && c(t.meta) && (s = m({}, i.meta, t.meta)), o(i, s);
  }

  function o(t, n) {
    var r = m({}, t.meta, n);
    return m({}, {
      links: t.links,
      meta: r
    }, t.attributes, {
      id: t.id,
      type: t.type
    });
  }

  function i(t) {
    return "[object Array]" === Object.prototype.toString.call(t);
  }

  function u(t) {
    return "[object String]" === Object.prototype.toString.call(t);
  }

  function c(t) {
    return "[object Object]" === Object.prototype.toString.call(t);
  }

  function s(t) {
    return t === n;
  }

  function p(t, n) {
    var r;
    if (i(t)) for (r = 0; r < t.length; r += 1) {
      n(t[r], r);
    } else if (c(t)) for (r in t) {
      Object.prototype.hasOwnProperty.call(t, r) && n(t[r], r);
    }
  }

  function f(t, n) {
    var r = [];
    return p(t, function (t, e) {
      r.push(n(t, e));
    }), r;
  }

  function d(t) {
    var n = !0;
    return p(t, function (t) {
      t !== !0 && (n = !1);
    }), n;
  }

  function l(t, n) {
    var r;
    return p(t, function (t) {
      var e = f(n, function (n, r) {
        return t[r] === n;
      });
      d(e) && (r = t);
    }), r;
  }

  function m() {
    var t = Object(null),
        n = Array.prototype.slice.call(arguments);
    return p(n, function (n) {
      p(n, function (n, r) {
        t[r] = n;
      });
    }), t;
  }

  var j = t.jsonapi || (t.jsonapi = {});
  j.parse = function (n) {
    var e, a;
    if (u(n)) try {
      e = t.JSON.parse(n);
    } catch (o) {
      if ("SyntaxError" === o.name) return n;
      throw o;
    } else {
      if (!c(n)) return n;
      e = n;
    }
    return s(e.data) && s(e.errors) && s(e.meta) ? e : e.jsonapi && e.jsonapi.parsed ? e : (a = r(e), a.jsonapi.parsed = !0, a);
  }, "object" == typeof exports ? c(module) && c(module.exports) && (exports = module.exports = j) : t.jsonapi = j;
}("undefined" == typeof window ? this : window);